import { Box } from '@mui/material'
import { useEffect, useState } from 'react'

import { Resource } from '@/clients/utoniq-core/schema'
import { Loading } from '@/components/organisms/loading'
import { TheoPlayerView } from '@/components/organisms/resourcePlayer/TheoPlayerView'
import { useDRMPlayer } from '@/core/resources/useDRMPlayer'

import { SoundPlayerControl } from './SoundPlayerControl'

type Props = {
  resource?: Resource
  autoplay?: boolean
}

export const SoundDRMPlayer = ({ resource, autoplay }: Props) => {
  // sliderを掴んでいるときの値
  const [slidingValue, setSlidingValue] = useState(0)

  const { player, currentTime, ref, accessToken } = useDRMPlayer({
    source: {
      dashUri: resource?.dashUri || '',
      hlsUri: resource?.hlsUri || '',
    },
    opts: {
      chromeless: true,
    },
  })

  useEffect(() => {
    /**
     * @note
     * DRMの復号処理はplayメソッドに応じて呼び出されるため、マウント時に自動再生→即停止することで音声の事前ロードを行う
     */
    if (!(player && accessToken)) return

    player.play()
    if (!autoplay) player.pause()
  }, [player, autoplay, accessToken])

  return (
    <Box>
      {(!player || !player?.duration) && (
        <Box
          sx={{
            position: 'absolute',
            zIndex: 2,
            inset: 0,
            margin: 'auto',
            width: 'fit-content',
            height: '100dvh',
            pointerEvents: 'none',
          }}
        >
          <Loading />
        </Box>
      )}
      <TheoPlayerView ref={ref} chromeless />
      {player && (
        <SoundPlayerControl
          sliderValue={slidingValue ? slidingValue : currentTime}
          onChange={(_, time) => {
            if (typeof time === 'number') setSlidingValue(time)
          }}
          onChangeCommitted={(_, time) => {
            if (typeof time === 'number') player.currentTime = time
            setSlidingValue(0)
          }}
          onRewind={() => {
            player.currentTime = player.currentTime - 10
          }}
          onForward={() => {
            player.currentTime = player.currentTime + 10
          }}
          onPause={() => {
            player.pause()
          }}
          onPlay={() => {
            player.paused ? player.play() : player.pause()
          }}
          isPlaying={!player.paused}
          duration={player?.duration}
        />
      )}
    </Box>
  )
}
